
import { useContext, useEffect, useRef, useState } from 'react';
import { CustomCursorContext } from '../customCursor/context/CustomCursorContext';
import { MazeResultContext } from '../customCursor/context/MazeResult';

import { gsap } from 'gsap';
import Draggable from 'gsap/Draggable';
import axios from 'axios';
gsap.registerPlugin(Draggable);
const url = process.env.REACT_APP_URL_LOCAL;
const Maze2 = ({ site, index }) => {
	const { setTypeCursor } = useContext(CustomCursorContext);
	const knob1Ref = useRef(null);
	const [knobValue, setKnobValue] = useState(0);
	const [result, setResult] = useState([]);
	const {setMazeTwoResult} = useContext(MazeResultContext);

	const addValue = (value) => {
		setResult((prev) => {
			const updatedResult = [...prev, value];
			const updatedResultLength = updatedResult.length;

			if (updatedResultLength <= 3) {
				return updatedResult;
			}

			return prev; // Pas de mise à jour si la longueur est >= 3
		});
	};

	useEffect(() => {
		knob1Ref.current = Draggable.create('#knob1', {
			type: 'rotation',
			inertia: true,
			onDrag: function () {
				const end = Math.round((-this.rotation / 6) % 60, 0);
				setKnobValue(end < 0 ? 60 + end : end);
			},
			onDragEnd: function () {
				const value = Math.round((-this.rotation / 6) % 60, 0);
				addValue(value < 0 ? 60 + value : value);
			},
		});
	}, []);

	// useEffect(() => {}, [result]);

	const handleResetKnobValue = () => {
		setMazeTwoResult('');
		setResult([]);
	};

	useEffect(() => {
		if (result.length === 3) {
			try {
				const sendData = async () => {
					const response = await axios.post(`${url}/maze-two`, {
						result,
					});
					if (response.data.success) {
						if (process.env.REACT_APP_MAZE_TWO === response.data.answer) {
							setMazeTwoResult(process.env.REACT_APP_MAZE_TWO);
						}
					} else {
						setMazeTwoResult('');
						const knobResult = document.querySelector(".maze-knob-value-result");
						knobResult.classList.add("hide-knob-result");
						setTimeout(() => {
							knobResult.classList.remove("hide-knob-result");
							handleResetKnobValue();
						}, 2000);
					}
				};
				sendData();
			} catch (error) {
				console.log(error);
			}
		}
		// eslint-disable-next-line
	}, [result]);

	

	return (
		<>
			<div
				onMouseEnter={() => {
					setTypeCursor('normal');
				}}
				onMouseLeave={() => {
					setTypeCursor('default');
				}}
				className="portfolio-element-container"
			>
				{/* <div className="portfolio-element-title">{site.title}</div> */}
				<div className="portfolio-element-container-index">{index < 10 ? `0${index + 1}.` : index + 1 + ' '}</div>
				<div className="portfolio-element-content-maze2">
					<div
						className="portfolio-element-image"
					>
						<div className="maze-knob-container">
							<div className="maze-knob-value">{knobValue}</div>
							<div style={{ position: 'relative', zIndex: 0 }}>
								<div className="knob-shadow"></div>
								<div className="knob-shadow2"></div>
								<div
									ref={knob1Ref}
									className="maze-knob"
									id="knob1"
								></div>
							</div>
							<div className="reset-knob-value">
								<div
									onClick={handleResetKnobValue}
									className="maze-knob-reset"
								>
									reset
								</div>
							</div>
						</div>
					</div>
					<div className="portfolio-element-card-maze-2">
						<h1>{site.title}</h1>
						<div className='maze-knob-value-result-container'>
							<div className="maze-knob-value-result">
								{result[0] && `${result[0]}`}
								{result[1] && `-${result[1]}`}
								{result[2] && `-${result[2]}`}
							</div>
						</div>
						<p>
							{site.short} <br></br>
							<br></br> {site.content.description}
						</p>

						<div className="live-demo-card-details">
							{site.repository.live && (
								<a
									href={site.repository.live}
									target="_blank"
									rel="noreferrer"
								>
									visit the website
								</a>
							)}
							{site.repository.frontend && (
								<a
									href={site.repository.frontend}
									target="_blank"
									rel="noreferrer"
								>
									<ion-icon name="logo-github"></ion-icon>
								</a>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Maze2;
